import axios from '..';
import type {
  DeleteBadgesReqType,
  GetBadgeApplicationReqType,
  GetBadgeApplicationStatusReqType,
  PatchApplicationApprovalReqType,
  PatchBadgesReqType,
  PostBadgeApplicationReqType,
  PostBadgesReqType,
} from './req';
import type {
  DeleteBadgesResType,
  GetBadgeApplicationStatusResType,
  GetBadgeUniversityApplicationResType,
  GetBadgesResType,
  PatchApplicationApprovalResType,
  PatchBadgesResType,
  PostBadgeApplicationResType,
  PostBadgesResType,
} from './res';

export const badgeApi = {
  GET: async () => (await axios.get<GetBadgesResType>('/badges')).data,
  POST: async (body: PostBadgesReqType) =>
    (await axios.post<PostBadgesResType>('/badges', body)).data,
  PATCH: async (body: PatchBadgesReqType) =>
    (await axios.patch<PatchBadgesResType>('/badges', body)).data,
  DELETE: async (body: DeleteBadgesReqType) =>
    (await axios.delete<DeleteBadgesResType>(`/badges/${body.id}`)).data,
  APPLICATION: {
    GET: async (params: GetBadgeApplicationReqType) =>
      (await axios.get<GetBadgeUniversityApplicationResType>('/badges/application', { params }))
        .data,
    POST: async (body: PostBadgeApplicationReqType) =>
      (await axios.post<PostBadgeApplicationResType>('/badges/application', body)).data,
    APPROVAL: async ({ applicationId, ...body }: PatchApplicationApprovalReqType) =>
      await axios.patch<PatchApplicationApprovalResType>(
        `/badges/application/${applicationId}/approval`,
        body,
      ),
    STATUS: {
      GET: async ({ userId }: GetBadgeApplicationStatusReqType) =>
        (
          await axios.get<GetBadgeApplicationStatusResType>(
            `/badges/application/users/${userId}/status`,
          )
        ).data,
    },
  },
};
